// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"7":"admin-dashboard","361":"panel-vendedores","444":"notifications-panel","448":"panel-tecnicos","509":"crear-work-order","881":"admin-panel"}[chunkId] + "." + {"7":"f3497ca9","361":"4edd9621","444":"484fe6a3","448":"e76beb43","509":"eecbf55c","881":"52a71ebc"}[chunkId] + ".js";
};